export default "__VITE_ASSET__BxPr$cSi__"